import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import { PermitApplicationStep } from "../../PermitApplicationContext";
import { getStepLabel, getStepIndex, TOTAL_STEPS } from "../../constants";

export interface MobileStepperProps {
  currentStep: PermitApplicationStep;
}

export const MobileStepper: React.FC<MobileStepperProps> = ({ currentStep }) => {
  const stepIndex = getStepIndex(currentStep);
  const stepNumber = stepIndex + 1;
  const progressValue = (stepNumber / TOTAL_STEPS) * 100;

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
        <Typography variant="body2" fontWeight="medium">
          Step {stepNumber} of {TOTAL_STEPS}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {getStepLabel(currentStep)}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progressValue}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: "action.hover",
          "& .MuiLinearProgress-bar": {
            borderRadius: 4,
          },
        }}
      />
    </Box>
  );
};

export default MobileStepper;
